import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import useMediaQuery from "../../hooks/useMediaQuery";

const NotFound = ({
  title = "Page not found",
  message = "The page you were looking for is not here.",
}) => {
  const aboveMediumScreens = useMediaQuery("(min-width: 1061px)");

  return (
    <section
      className={`min-h-screen relative overflow-hidden bg-off-black
      text-off-white flex items-center ${
        aboveMediumScreens ? "mt-[72px] px-[7%]" : "mt-[41px] px-6"
      }`}
    >
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="py-24"
      >
        <h1
          className={`font-generalsans font-extrabold leading-[1.05] ${
            aboveMediumScreens ? "text-8xl" : "text-4xl"
          }`}
        >
          {title}
        </h1>
        <p
          className={`mt-6 font-satoshi text-clay ${
            aboveMediumScreens ? "text-xl" : "text-base"
          }`}
        >
          {message}
        </p>
        <div className="mt-10 flex gap-8 font-satoshi uppercase">
          <Link
            to="/"
            className="text-off-white transition-colors duration-300 hover:text-blue"
          >
            Home
          </Link>
          <Link
            to="/blog"
            className="text-off-white transition-colors duration-300 hover:text-blue"
          >
            Blog
          </Link>
        </div>
      </motion.div>
    </section>
  );
};

export default NotFound;
